"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOCKET_ALARM = exports.MERIDIAN_LINK = exports.DOCASSEMBLE = void 0;
var DOCASSEMBLE = 'docassemble';
exports.DOCASSEMBLE = DOCASSEMBLE;
var MERIDIAN_LINK = 'meridianLink';
exports.MERIDIAN_LINK = MERIDIAN_LINK;
var DOCKET_ALARM = 'docketAlarm';
exports.DOCKET_ALARM = DOCKET_ALARM;